import { FC, PropsWithChildren, useState } from 'react';
import { DataTypeType } from 'modules/domains';
import { SearchFieldContext } from './SearchFieldContext';
import { FieldSearchOption } from '../../../types';

export const SearchFieldContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const [option, changeOption] = useState<FieldSearchOption | null>(null);
  const [dataType, changeDataType] = useState<DataTypeType>();

  const value = {
    option,
    changeOption,
    changeDataType,
    dataType,
  };

  return <SearchFieldContext.Provider value={value}>{children}</SearchFieldContext.Provider>;
};
